const GlassDesignerTypes = {

  // Editor View Level Types
  EditorViewLevelTypes: {
    normal: 'normal',
    cutting: 'cutting',
    cutouts: 'cutouts',
    technical: 'technical',
    view3D: 'view3D'
  },

  // UI Layers for selection
  // Higher layers have priority over lower layers
  EditorUILayers: {
    default: 0,
    selection: 1,
    editing: 2,
    editableLabel: 3,
    activeTool: 4
  },

  UnitScaleTypes: {
    millimetres: 'millimetres',
    inches: 'inches'
  },
  UnitScaleTypeLookup: [
    { value: 'millimetres', name: 'Millimetres' },
    { value: 'inches', name: 'Inches' }
  ],

  PopoverPositions: {
    left: 'left',
    center: 'center',
    right: 'right'
  },

  // Datum reference point types
  DatumTypes: {
    glassSegment: 'glassSegment',
    glassSegmentStart: 'glassSegmentStart',
    glassSegmentEnd: 'glassSegmentEnd',
    shapeCircleEdge: 'shapeCircleEdge',
    shapeBoundsEdge: 'shapeBoundsEdge',
    datumLine: 'datumLine',
    datumLineStart: 'datumLineStart',
    datumLineEnd: 'datumLineEnd',
    hole: 'hole',
    position: 'position'
  },

  // Segment types
  SegmentTypes: {
    line: 'line',
    arc: 'arc'
  },

  // Shape Types used in the library items
  LibraryItemShapeTypes: {
    circle: 'circle',
    semiCircle: 'semiCircle',
    oval: 'oval',
    rectangle: 'rectangle',
    custom: 'custom'
  },

  // Shape Types Lookup used in the library item
  LibraryItemShapeTypeLookup: [
    { name: 'Circle', value: 'circle' },
    { name: 'Rectangle', value: 'rectangle' },
    { name: 'Custom', value: 'custom' },
  ],

  // Editor Order Item Data types
  // Used internally to associated order items with the editor
  // Stored in the shapeData field for OrderItems
  EditorOrderItemDataTypes: {
    glassShape: 'glassShape',
    assemblyGroup: 'assemblyGroup', // Assembly group for the glass shape
    generalItem: 'generalItem',     // General items within a glass shape
    shapeService: 'shapeService',
    cutoutService: 'cutoutService',   // Edge/Corner cutouts
    edgeworkService: 'edgeworkService',
    minPriceItem: 'minPriceItem',
    minInvoiceItem: 'minInvoiceItem',
    deliveryItem: 'deliveryItem',
    panelItemService: 'panelItemService',
    splitService: 'splitService',
    stampService: 'stampService',
    customItem: 'customItem'          // Anything by the user
  },


  // Editing types
  ShapeEditingTypes: {
    shape: 'shape',
    segment: 'segment',
    segmentStart: 'segmentStart',
    hole: 'hole'
  },

  // Move Editing Directions
  MoveEditDirectionTypes: {
    up: 'up',
    right: 'right',
    down: 'down',
    left: 'left'
  },

  // Move Segment Types
  MoveSegmentTypes: {
    move: 'move',
    extend: 'extend',   // Extend/Extrude
    taper: 'taper'
  },
  MoveSegmentTypeLookup: [
    { name: 'Move', value: 'move' },
    { name: 'Extend', value: 'extend' },
    { name: 'Taper', value: 'taper' },
  ],

  // Arc Edit Types
  ArcEditTypes: {
    radius: 'radius',
    arcHeight: 'arcHeight'
  },
  ArcEditTypeLookup: [
    { name: 'Radius', value: 'radius' },
    { name: 'Arc Height', value: 'arcHeight' },
  ],



  // Axis aligned types
  // Used for axis aligned measurements, etc
  AxisTypes: {
    horizontal: 'horizontal',
    vertical: 'vertical'
  },

  // Cutout Measurement Types
  // Used for edge cutouts / shape groups
  CutoutMeasurementTypes: {
    center: 'center',
    edge: 'edge'
  },
  CutoutMeasurementTypeLookup: [
    { name: 'Center', value: 'center' },
    { name: 'Edge', value: 'edge' },
  ],

  // Library item types
  LibraryItemTypes: {
    shape: 'shape',
    kit: 'kit',
    assembly: 'assembly',
    centerCutOut: 'centerCutOut',
    edgeCutOut: 'edgeCutOut',
    cornerCutOut: 'cornerCutOut',
    panelItem: 'panelItem'
  },
  LibraryItemTypeLookup: [
    { name: 'Shape', value: 'shape' },
    { name: 'Kit', value: 'kit' },
    { name: 'Assembly', value: 'assembly' },
    { name: 'Center Cut Out', value: 'centerCutOut' },
    { name: 'Edge Cut Out', value: 'edgeCutOut' },
    { name: 'Corner Cut Out', value: 'cornerCutOut' },
    { name: 'Panel Item', value: 'panelItem' },
  ],

  // Library Item filters
  LibraryItemFilterTypes: {
    standard: 'standard',
    customerTemplate: 'customerTemplate',
    allTemplate: 'allTemplate'
  },

  // Touch Camera modes
  TouchCameraModes: {
    touchNone: 'touchNone',
    touchPan: 'touchPan',
    touchPanZoom: 'touchPanZoom',
  },

  // Dimension types
  DimensionTypes: {
    // Special Flag: All. Used to help enable all dimensions
    all: 'all',

    linearGlassSegmentDimension: 'linearGlassSegmentDimension',
    angularGlassSegmentDimension: 'angularGlassSegmentDimension',
    linearGlassStandardDimension: 'linearGlassStandardDimension',
    linearGlassOverallDimension: 'linearGlassOverallDimension',
    linearGlassProjectedDimension: 'linearGlassProjectedDimension',
    glassHoleOffsetDimension: 'glassHoleOffsetDimension',
    glassHoleSizeDimension: 'glassHoleSizeDimension',
    glassDatumLineDimension: 'glassDatumLineDimension',
    infoLineDimension: 'infoLineDimension',

    // Editing dimensions
    editingLineDimension: 'editingLineDimension',
    editingCutoutDimension: 'editingCutoutDimension',
    editingPointDimension: 'editingPointDimension'
  },

  // Dimension Link types
  // Not used...
  DimensionLinkTypes: {
    none: 'none',
    glassSegment: 'glassSegment',
    width: 'width',
    height: 'height'
  },

  // Hole Measure Points
  HoleMeasurePointTypes: {
    // Horizontal
    left: 'left',
    center: 'center',
    right: 'right',

    // Vertical
    top: 'top',
    middle: 'middle',
    bottom: 'bottom'
  },
  HoleMeasurePointTypeLookup: [
    { name: 'Left', value: 'left' },
    { name: 'Center', value: 'center' },
    { name: 'Right', value: 'right' },
    { name: 'Top', value: 'top' },
    { name: 'Middle', value: 'middle' },
    { name: 'Bottom', value: 'bottom' },
  ],

  // Cutout Types
  CutoutTypes: {
    center: 'center',   // Inside the shape, treated as 'holes'
    edge: 'edge',       // On a single segment, treated as part of the shape outline
    corner: 'corner'    // Across multiple segments, treated as part of the shape outline
  },

  // Undo Command Types
  UndoCommandTypes: {
    add: 'add',
    update: 'update',
    delete: 'delete'
  },

  // Tool Types
  ToolTypes: {
    // Sidebar tools
    selectTool: 'selectTool',
    cutTool: 'cutTool',
    stretchTool: 'stretchTool',
    splitTool: 'splitTool',
    measureTool: 'measureTool',
    skewTool: 'skewTool',
    shapeTool: 'shapeTool',         // DEPRECATED
    edgeCutoutTool: 'edgeCutoutTool',   // DEPRECATED TOO?

    // Library tools
    addGlassShape: 'addGlassShape',
    addCenterCutout: 'addCenterCutout',
    addEdgeCutout: 'addEdgeCutout',
    addCornerCutout: 'addCornerCutout',
    addPanelItem: 'addPanelItem',

    // Integrated editing tools
    dimensionEditTool: 'dimensionEditTool',
    dimensionEditDatumTool: 'dimensionEditDatumTool',
    segmentMoveTool: 'segmentMoveTool',
    centerCutoutMoveTool: 'centerCutoutMoveTool',
    itemMoveTool: 'itemMoveTool',

    holeEditTool: 'holeEditTool',
    segmentAddPoints: 'segmentAddPoints'
  },

  // Object Event Types
  ObjectEventTypes: {
    objectCaptured: 'objectCaptured',
    objectMoved: 'objectMoved',
    objectReleased: 'objectReleased',
    objectUpdated: 'objectUpdated'
  },

  ReviewGroupTypes: {
    panel: 'panel',
    edgework: 'edgework',
    cutout: 'cutout',
    runout: 'runout',
    cornerRadius: 'cornerRadius',
    misc: 'misc'
  }

  
}

module.exports = GlassDesignerTypes